import React, { Component } from 'react';
import Wrapper from './../../../../../common/component/Wrapper';
import {
    getTitleTable, formatMoney, columnsTable,
    getDataSource
} from '../../../../../../../helpers/functions';

import { DATE_TIME_FORMAT } from '../../../../../../../constants/Define';
import { FormWrapperItem, ListComponent } from '../../../../../common/component/Index';
import './RedeemtionDetail.less';

let permisionActions = [];
const defaultState = {

};

const Cols = [
    'propertyId', 'propertyName', 'usedCount',
];
export default class RedeemtionDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            titleItemTable: getTitleTable(Cols, [], ['propertyId']),
            modelItem: Cols,
            componentTable: {
                propertyName: {
                    sorter: (i, k) => i.propertyName.length - k.length,
                    key: 'propertyName',
                    width: 250,
                    fixed: 'left',
                },
                usedCount: {
                    sorter: (i, k) => i.usedCount.length - k.length,
                    key: 'usedCount',
                    align: 'left',
                },
            },
        };
    }

    componentDidMount() {

    }

    render() {
        const { t, data, loading } = this.props;
        const { items } = data;
        const { titleItemTable, modelItem, componentTable } = this.state;

        return (
            <ListComponent
                scroll={{ y: null }}
                classParent="m-0 p-0 col-md-12" classChildren="m-0 p-0"
                marginTop={'0'} marginBottom={'0'}
                loading={{ spinning: loading, size: 'large' }}
                rowKey={(record, k) => record.propertyId ? record.propertyId : k}
                dataSource={getDataSource(items || [], modelItem)}
                columns={columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'report'
                })}
                pagination={{ total: data.totalCount, totalPage: data.totalPage, current: data.pageIndex, pageSize: data.pageSize }}
                onChange={this.props.onTableChange}
                componentTableList={{}}
                hideSettings={true}
            />
        );
    }

}

RedeemtionDetail.defaultProps = {
    data: {},
    filters: {},
    loading: false,
    onTableChange: () => { },
}

